export const useCurrentPage = (param: MaybeRefOrGetter<Readonly<string>> = 'page', startPage: MaybeRefOrGetter<Readonly<number>> = 1) => {
    const route = useRoute();

    return computed(() => {
        const page = parseInt(route.query[toValue(param)], 10);
        return !isNaN(page) ? page : toValue(startPage);
    });
};
